import { render, staticRenderFns } from "./NetworkMetrics.vue?vue&type=template&id=89d22942&scoped=true"
import script from "./NetworkMetrics.vue?vue&type=script&lang=js"
export * from "./NetworkMetrics.vue?vue&type=script&lang=js"
import style0 from "./NetworkMetrics.vue?vue&type=style&index=0&id=89d22942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d22942",
  null
  
)

export default component.exports